export enum ContentWidth {
  Restricted = 'restricted',
  FullWidth = 'full-width',
}
